
import { formatMoney, isHighlighted, isSuperHighlighted, showBathrooms, showBedrooms, showGuests, showM2, showRooms } from "@Utils/Functions"
import { CardImageGallery } from "../../Components/Property/PropertyCard/CardImageGallery/web"
import { useEffect, useState } from "react"
import { OwnerLogo } from "shared-components/Components/Property/OwnerLogo/web"
import { useContext } from "react"
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context"
import "./ListingCard.less"

import dynamic from "next/dynamic"
import { LeadButtons } from "shared-components/Components/Property/InformationRequest/LeadButtons/web"
import { Favorite } from "shared-components/Components/Property/Favorite/web"
import { TagEvent } from "shared-components/Components/TagEvent/web"
//@ts-ignore
const FacilitiesCard = dynamic(
    () => import("shared-components/Components/Property/FacilitiesCard/web").then(mod => mod.FacilitiesCard),
    { ssr: false }
)

type Event = {
    tag: string
    show: boolean,
    link: string,
    logo: string,
    fecha_inicio_evento: string
}

type ListingCardProps = {
    preloadImg?: boolean
    data: {
        id?: any,
        legacy_propID?: any,
        isProject?: any,
        img?: any,
        owner?: {
            logo?: any,
            name?: any,
            inmoLink?: any,
            inmoPropsLink?: any,
            inmofull?: any,
        },
        price?: any,
        currency?: any,
        currency_id?: any,
        hidePrice?: any,
        highlight?: any,
        property_type_id?: any,
        operation_type_id?: any,
        bedrooms?: any,
        bathrooms?: any,
        rooms?: any,
        m2?: any,
        guests?: any,
        title?: any,
        description?: any,
        neighborhood?: any,
        estate?: any,
        facilities?: any,
        link?: any,
        isExternal?: any,
        event?: Event,
    }
}

export const ListingCard = ({ data, preloadImg = false }: ListingCardProps) => {
    const [hover, setHover] = useState(false)
    const isSuperHigh = isSuperHighlighted(data.highlight)
    const { country_code } = useContext(ConfigStateContext)
    const [idealFilters, setIdealFilters] = useState<any>(false)

    const tags = genTagsText(data, country_code)
    const onHover = (e?: any) => { setHover(true) }
    const onHoverEnd = (e?: any) => { setHover(false) }

    const ids = ["190663135"]

    useEffect(() => {
        if (!data.isProject && data && 'operation_type_id' in data && 'property_type_id' in data) {
            setIdealFilters({
                operation_type_id: data.operation_type_id,
                property_type_id: [data.property_type_id],
                maxPrice: data.price + (data.price * 0.20),
                bedrooms: [data.bedrooms],
                currencyID: Number(data.currency_id)
            })
        }
    }, [])

    if (!data || !data.id) return null

    return (
        <div onMouseEnter={onHover} onMouseLeave={onHoverEnd} className={`listingCard ${isSuperHigh ? 'isSuperHighlighted' : ''} ${country_code} ${ids.includes(data.id.toString()) ? "special" : ""}`} >
            <CardLink data={data} className="lc-cardCover">
                <div className="lc-galleryWrap">
                    <CardImageGallery
                        id={data.legacy_propID}
                        idProject={data.id}
                        mode={data.isProject ? "project" : "property"}
                        image={data.img}
                        hover={hover}
                        preloaded={preloadImg}
                        width={500}
                        height={isSuperHigh ? 386 : 260}
                    />
                </div>
                <div className="lc-cardCoverTop">
                    <div style={{ flex: 1 }}>
                        {tags?.map((t, i) => <span className={`lc-tags tag-${t.name}`} key={i}>{t.text}</span>)}
                        {
                            ids.includes(data.id.toString()) &&
                            <>
                                <span className="lc-tags" key={8}>🌟 oportunidad</span>
                                <span className="lc-tags" key={8}>🚀 tendencia</span>
                            </>
                        }
                    </div>
                    <div>
                        <Favorite id={data.legacy_propID} type="justIcon" />
                    </div>
                </div>

                {(data.isProject && data.event.show && data.event.logo !== "" && data.event.tag !== "" && data.event.link !== "") ?
                    <TagEvent event={data.event} /> : null
                }
            </CardLink>

            <div className="lc-dataWrapper">
                {isSuperHigh && country_code != 'ce3' &&
                    <OwnerLogo
                        logo={data.owner.logo}
                        name={data.owner.name}
                        inmoLink={data.owner.inmoLink}
                        inmoPropsLink={data.owner.inmoPropsLink}
                        inmoFull={data.owner.inmofull}
                    />
                }
                <CardLink data={data} className="lc-data">
                    <div className="lc-price">
                        {data.currency && data.price && data.price >= 5 && !data.hidePrice
                            ? <>
                                <strong>{data.isProject ? "Desde" : ''} {data.currency} {formatMoney(data.price)}</strong>
                                {country_code === "ce3" && <span className="qty-price">/noche</span>}
                            </>
                            : <strong>Consultar</strong>
                        }



                    </div>
                    <div className="lc-typologyTag">
                        {showBedrooms([data.property_type_id], data.operation_type_id) &&
                            <strong>{data.bedrooms == 0 ? 'Mono' : data.bedrooms + ' Dorm.'} </strong>
                        }
                        {showRooms([data.property_type_id], data.operation_type_id) &&
                            <strong>{data.rooms == 1 ? data.rooms + ' Ambiente' : data.rooms + ' Ambientes'} </strong>
                        }
                        {showBathrooms([data.property_type_id], data.operation_type_id) &&
                            <strong>{data.bathrooms} {data.bathrooms > 1 ? "Baños" : "Baño"}</strong>
                        }
                        {showM2(data.operation_type_id) && data.m2 > 0 &&
                            <strong>{data.m2} m²</strong>
                        }
                        {showGuests(data.operation_type_id) &&
                            <strong>{data.guests} Huéspedes</strong>
                        }
                    </div>
                    <h2>{data.title}</h2>

                    {isSuperHigh &&
                        <p className="lc-description">{data.description}</p>
                    }

                    <strong className="lc-location">{data.neighborhood}, {data.estate}</strong>

                    {country_code === "ce3" &&
                        <div style={{ marginTop: '-10px', maxWidth: '268px' }}>
                            <FacilitiesCard facilities={data.facilities ?? []} dataFormat="idsArray" />
                        </div>
                    }

                    <LeadButtons id={data.legacy_propID} mode={data.isProject ? "project" : "property"} isInListing idealFilters={idealFilters} isProject={data.isProject} />
                </CardLink>
            </div>
        </div>
    )
}

const genTagsText = (data, country_code) => {
    let tags = []
    if (country_code == 'ce3' && data.seaDistanceName !== null)
        tags.push({
            name: "seaDistance",
            text: `${data.seaDistanceName} ${data.seaDistanceName != "frente al mar" ? "del mar" : ''}`
        })

    if (data.highlight) {
        if (isSuperHighlighted(data.highlight)) {
            tags.push({ name: "isSuperHighlighted", text: 'Super Destacado' })
        } else if (isHighlighted(data.highlight)) {
            tags.push({ name: "isHighlighted", text: "Destacado" })
        }
    }

    if (data.isProject) tags.push({ name: "isProject", text: "Proyecto" })
    if (data.isExternal) tags.push({ name: "isExternal", text: "Ficha externa" })
    if (data.tour3d) tags.push({ name: "tour3d", text: "Tour Virtual" })

    return tags
}

const CardLink = ({ children, data, className = "" }) => {
    let link = data.link
    let isExternal = data.isExternal

    //@hardcoded - pedido especial de hardcodeo, en algun momento habria que sacar esto y usar directamente data.link y data.isExternal en el render del componente
    if (data.isProject && (data.id == 13755 || data.legacy_propID == 189503363)) {
        link = 'https://www.campiglia.com.uy/propiedades_destacadas'
        isExternal = true
    }
    //END @hardcoded - pedido especial de hardcodeo
    const clickHandler = (e: any) => {
        const isOverlayClick = e.target.classList.contains('overlay-cta') || e.target.closest('.overlay-cta');

        if (isOverlayClick) {
            e.preventDefault();
        } else if (data.isExternal) {
            e.preventDefault();

            window.open(
                data.link,
                "_blank",
                "location=yes,height=670,width=620,scrollbars=yes,status=yes"
            );
        }
    }

    return <a className={className} target="_blank" title={data.title}
        href={!data.isExternal ? link : '#'}
        rel={isExternal ? 'nofollow' : null}
        onClick={clickHandler}
    >
        {children}
    </a>
}